export enum Label {
  DATA_RELEASE = 'DATA_RELEASE',
  DOWN_TIME = 'DOWN_TIME',
  ENHANCEMENTS = 'ENHANCEMENTS',
  KNOWN_ISSUES = 'KNOWN_ISSUES',
  MISC = 'MISC',
  INSIGHT = 'INSIGHT'
}

export type Notification = {
  id: number
  startDate: string
  endDate: string
  message: string
  label: Label
  isReadForUser: boolean
}

export function sortNotifications(notifications: Notification[] | undefined) {
  if (notifications === undefined) {
    return undefined
  }

  return [...notifications].sort((a, b) => {
    if (a.startDate < b.startDate) {
      return 1
    }
    if (b.startDate < a.startDate) {
      return -1
    }

    return b.id - a.id
  })
}

export function determineUnreadCount(
  notifications: Notification[] | undefined
): number {
  return (
    notifications?.filter((notification) => !notification.isReadForUser)
      ?.length || 0
  )
}

export function determineNotificationAge(today: any, startDate: string) {
  const cutOff = 30 // notification publication date will be displayed instead of "x days ago" for notifications older than cutoff days

  // const dateToday:any = new Date(today);
  const notificationDate: any = new Date(startDate)
  const oneDay = 24 * 60 * 60 * 1000 // hours*minutes*seconds*milliseconds

  const diffDays = Math.floor(Math.abs((today - notificationDate) / oneDay))

  if (diffDays > cutOff) {
    const day = notificationDate.getDate()
    const month = notificationDate.toLocaleString('default', { month: 'short' })
    const year = notificationDate.getFullYear()
    return day + ' ' + month + ' ' + year
  } else if (diffDays > 7) {
    return diffDays + ' days ago'
  } else if (diffDays === 1) {
    return 'Yesterday'
  } else if (diffDays === 0) {
    return 'Today'
  } else if (diffDays <= 7) {
    return notificationDate.toLocaleString('default', { weekday: 'long' })
  }

  return ''
}
